import { faMap } from "@fortawesome/free-regular-svg-icons";
import TableLinkButtonComponent from "../../../../../../../../common/components/table/button/link/table-link-button.component";
import TableComponent, {
  TableProps,
} from "../../../../../../../../common/components/table/table.component";
import uuidService from "../../../../../../../../common/utils/uuid/uuid.service";
import { useAppContext } from "../../../../../../../../context/app.context";
import { FC, useMemo } from "react";
import OrderOptimizerTaxiDetailsHiddenDetailsCenterTablesOrdersOrderTableRow from "../../types/order-optimizer-taxi-details-hidden-details-center-tables-orders-order-table-row";
import orderOptimizerTaxiDetailsHiddenDetailsCenterTablesOrdersOrderTableHelper from "./order-optimizer-taxi-details-hidden-details-center-tables-orders-order-table.helper";
import OrderOptimizerDetailsTableDotComponent from "../../../../../../common/dot/order-optimizer-details-orders-table-dot.component";
import {
  OrderOptimizerTaxiDetailsItemDriver,
  OrderOptimizerTaxiDetailsItemStepsOrdersPoints,
} from "../../../../common/types/order-optimizer-taxi-details-item";
import orderOptimizerTaxiDetailsHelper from "../../../../order-optimizer-taxi-details.helper";

type OrderOptimizerTaxiDetailsHiddenDetailsCenterTablesOrdersOrdTableProps =
  Pick<TableProps, "isError" | "isLoading"> & {
    driver: OrderOptimizerTaxiDetailsItemDriver | null;
    allStepPoints: OrderOptimizerTaxiDetailsItemStepsOrdersPoints[];
    stepPoints: OrderOptimizerTaxiDetailsItemStepsOrdersPoints[];
    stepOffset: number;
  };

const OrderOptimizerTaxiDetailsHiddenDetailsCenterTablesOrdersOrdTableComponent: FC<
  OrderOptimizerTaxiDetailsHiddenDetailsCenterTablesOrdersOrdTableProps
> = (props) => {
  const { selectedAppLanguage } = useAppContext();

  const columns = useMemo(() => {
    return orderOptimizerTaxiDetailsHiddenDetailsCenterTablesOrdersOrderTableHelper.getColumns();
  }, [selectedAppLanguage]);

  const createTableRow = (
    detailsStepsOrdersPointsItem: OrderOptimizerTaxiDetailsItemStepsOrdersPoints,
    index: number,
  ): OrderOptimizerTaxiDetailsHiddenDetailsCenterTablesOrdersOrderTableRow => {
    const timeLabel = orderOptimizerTaxiDetailsHelper.getTimeLabel(
      detailsStepsOrdersPointsItem.time,
    );
    const timeTitle = orderOptimizerTaxiDetailsHelper.getTimeLabel(
      detailsStepsOrdersPointsItem.time,
    );

    const distanceLabel = orderOptimizerTaxiDetailsHelper.getDistanceLabel(
      detailsStepsOrdersPointsItem.distance,
    );
    const distanceTitle = orderOptimizerTaxiDetailsHelper.getDistanceLabel(
      detailsStepsOrdersPointsItem.distance,
    );

    const haltingTimeLabel = orderOptimizerTaxiDetailsHelper.getTimeDeltaLabel(
      detailsStepsOrdersPointsItem.haltingTime,
    );
    const haltingTimeTitle = orderOptimizerTaxiDetailsHelper.getTimeDeltaLabel(
      detailsStepsOrdersPointsItem.haltingTime,
    );

    const dotColor = "#d9d9d9";
    const stepPointIndex = props.stepOffset + index;

    const isFirstPoint = stepPointIndex === 0;
    const isLastStepPoint = index === props.stepPoints.length - 1;

    const googleMapsPoints: OrderOptimizerTaxiDetailsItemStepsOrdersPoints[] =
      [];

    if (!isFirstPoint) {
      googleMapsPoints.push(props.allStepPoints[stepPointIndex - 1]);
    }
    googleMapsPoints.push(props.allStepPoints[stepPointIndex]);

    return {
      id: uuidService.generate(),
      value: {
        humanId: (
          <div className="order_optimizer_taxi_details_hidden_details_center_tables_order__humanId">
            <span style={{ width: "8px" }} title={String(stepPointIndex + 1)}>
              {stepPointIndex + 1}
            </span>
            <OrderOptimizerDetailsTableDotComponent color={dotColor} />
          </div>
        ),
        address: (
          <div title={detailsStepsOrdersPointsItem.displayName}>
            {detailsStepsOrdersPointsItem.displayName}
          </div>
        ),
        time: (
          <div
            className={isLastStepPoint ? "last_driver_time" : ""}
            title={timeTitle}
          >
            {timeLabel}
          </div>
        ),
        haltingTime: (
          <div
            title={haltingTimeTitle!}
            className={
              detailsStepsOrdersPointsItem.haltingTime < 0 ? "time_delayed" : ""
            }
          >
            {haltingTimeLabel}
          </div>
        ),
        distance: <div title={distanceTitle}>{distanceLabel}</div>,
        actions: (
          <TableLinkButtonComponent
            icon={faMap}
            openInNewTab
            to={orderOptimizerTaxiDetailsHelper.getGoogleMapsUrl(
              googleMapsPoints,
              props.driver?.startLat,
              props.driver?.startLon,
              isFirstPoint,
              false,
            )}
            type="primary"
          />
        ),
      },
    };
  };

  const rows: OrderOptimizerTaxiDetailsHiddenDetailsCenterTablesOrdersOrderTableRow[] =
    useMemo(() => {
      return props.stepPoints.map(createTableRow);
    }, [props.stepPoints, selectedAppLanguage]);

  return (
    <TableComponent
      columns={columns}
      rows={rows}
      isLoading={props.isLoading}
      isError={props.isError}
      noHeader
    />
  );
};

export default OrderOptimizerTaxiDetailsHiddenDetailsCenterTablesOrdersOrdTableComponent;
